import { apiWithAuth } from "./utils";

export class Deal {
  constructor(private readonly mountPath: string) {}

  // Create a new deal
  async createDeal(dealData: { [key: string]: any }) {
    return await apiWithAuth.post(this.mountPath, dealData);
  }

  // Get a single deal by ID
  async getDealById(id: number) {
    return await apiWithAuth.get(`${this.mountPath}/${id}`);
  }

  // List all deals (optionally support pagination/query)
  async listDeals(queryParams: { [key: string]: any } = {}) {
    const queryString = new URLSearchParams(queryParams).toString();
    return await apiWithAuth.get(`${this.mountPath}?${queryString}`);
  }

  // Update deal by ID
  async updateDeal(id: number, updateData: { [key: string]: any }) {
    return await apiWithAuth.put(`${this.mountPath}/${id}`, updateData);
  }

  // Delete deal by ID
  async deleteDeal(id: number) {
    return await apiWithAuth.delete(`${this.mountPath}/${id}`);
  }

  // Bulk upload deals via FormData
  async bulkUploadDeals(formData: FormData) {
    return await apiWithAuth.post(`${this.mountPath}/bulk-upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  // Search deals using Elasticsearch
  async searchDeals(query: string, limit: number = 50, offset: number = 0) {
    const queryParams = new URLSearchParams({
      q: query,
      limit: limit.toString(),
      offset: offset.toString(),
    });
    return await apiWithAuth.get(`${this.mountPath}/search?${queryParams}`);
  }
}
